import { PrinterSchema } from "@redotech/redo-fulfillment-group-common/printer";
import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const watchPrinters = unaryStreamRpc({
  name: "watchPrinters",
  input: z.object({}),
  output: z.object({
    printers: z.array(PrinterSchema),
    notEnabled: z.boolean().optional(),
  }),
});
